<template>
  <div style="margin-top:30px">
    <el-form
    ref="form"
    :model="formData"
    :rules="formRules"
    label-width="120px"
    size="mini"
    @submit.native.prevent="handleSubmit"
  >
    <div style="display:flex">
      <div style="width: 600px;">
        <el-form-item label="是否启用状态" prop="Status">
           <el-radio-group v-model="formData.Status">
             <el-radio :label="1">是</el-radio>
             <el-radio :label="0">否</el-radio>
           </el-radio-group>
         </el-form-item>
         <el-form-item label="是否认证" prop="IsAuthentication">
           <el-radio-group v-model="formData.IsAuthentication">
             <el-radio :label="true">是</el-radio>
             <el-radio :label="false">否</el-radio>
           </el-radio-group>
         </el-form-item>
         <el-form-item label="账套编号" prop="AccountNo" >
         <el-input v-model="formData.AccountNo"></el-input>
         </el-form-item>
         <el-form-item label="账套名称" prop="AccountName" >
         <el-input v-model="formData.AccountName"></el-input>
         </el-form-item>
         <el-form-item label="账套路径" prop="AccountPath" >
         <el-input v-model="formData.AccountPath"></el-input>
         </el-form-item>
         <el-form-item label="单位全称" prop="FullName" >
         <el-input v-model="formData.FullName"></el-input>
         </el-form-item>
         <el-form-item label="单位简称" prop="ShortName" >
         <el-input v-model="formData.ShortName"></el-input>
         </el-form-item>
         <el-form-item label="所属行业" >
            <div style="display:flex">
              <div style="width:180px;margin-right:10px">
                <el-select v-model="formData.IndustryId1" placeholder="请选择"  @change="onIndustry1Select($event)">
                   <el-option
                     v-for="item in industryOptions1"
                     :key="item.value"
                     :label="item.IndustryName"
                     :value="item.IndustryId"
                   ></el-option>
                 </el-select>
              </div>
              <div style="width:180px">
                <el-select v-model="formData.IndustryId2" placeholder="请选择">
                   <el-option
                     v-for="item in industryOptions2"
                     :key="item.IndustryId"
                     :label="item.IndustryName"
                     :value="item.IndustryId"
                   ></el-option>
                 </el-select>
              </div>
            </div>
         </el-form-item>
         <el-form-item label="地区" prop="DistrictId">
            <div style="display:flex">
              <div style="width:180px;margin-right:10px">
                <el-select v-model="formData.DistrictId1" placeholder="请选择"  @change="onArea1Select($event)">
                   <el-option
                     v-for="item in areaOptions1"
                     :key="item.DistrictId"
                     :label="item.Name"
                     :value="item.DistrictId"
                   ></el-option>
                 </el-select>
              </div>
              <div style="width:180px;margin-right:10px">
                <el-select v-model="formData.DistrictId2" placeholder="请选择" @change="onArea2Select($event)">
                   <el-option
                     v-for="item in areaOptions2"
                     :key="item.DistrictId"
                     :label="item.Name"
                     :value="item.DistrictId"
                   ></el-option>
                 </el-select>
              </div>
              <div style="width:180px">
                <el-select v-model="formData.DistrictId3" placeholder="请选择">
                   <el-option
                     v-for="item in areaOptions3"
                     :key="item.DistrictId"
                     :label="item.Name"
                     :value="item.DistrictId"
                   ></el-option>
                 </el-select>
              </div>
            </div>
         </el-form-item>
         <!-- <el-form-item label="行政区"  prop="DistrictId">
          <tree-select
            ref="areaTreeSelect"
            :options="AreaTreeData"
            :value="formData.DistrictId"
            :props="AreaProps"
            :clearable="false"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onAreaTreeSelect($event)"
          />
         </el-form-item> -->
         <el-form-item label="单位地址" prop="Address" >
           <el-input v-model="formData.Address"></el-input>
         </el-form-item>
         <div style="display: flex;">
        <el-form-item label="纳税类型" prop="TaxNature" >
          <el-select v-model="formData.TaxNature" placeholder="请选择">
            <el-option
              v-for="item in TaxNatureData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税率%" prop="TaxRate" >
          <el-input v-model="formData.TaxRate"></el-input>
        </el-form-item>
         </div>
         <el-form-item label="备注" prop="Remark" >
           <el-input v-model="formData.Remark"></el-input>
         </el-form-item>
         <el-form-item>
           <el-button type="primary" native-type="submit">保存</el-button>
         </el-form-item>
      </div>
      <div style="width: 600px;">
        <el-form-item label="图片" class="notBottom" prop="ImgUrl">
          <el-upload class="file-up" :http-request="httpRequest" :before-upload="beforeUploadHandler" ref="uploadImg" action="#" list-type="picture-card"
            :show-file-list="true" accept=".jpg,.png,.jpeg" :on-exceed="masterFileMax" :limit="1" :file-list="ImgUrl">
            <i class="el-icon-plus plus"></i>
            <div slot="file" slot-scope="{ file }">
              <el-image style="width: 148px; height: 148px"  v-if="file.url" :src="file.url" fit="fill"></el-image>
              <label class="el-upload-list__item-status-label" v-if="file.isDefault">
                <i :class="{'el-icon-upload-success': true,'el-icon-check': true}"></i>
              </label>
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file.url)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="picRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="法人代表" prop="Legal" >
          <el-input v-model="formData.Legal"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="Phone" >
          <el-input v-model="formData.Phone"></el-input>
        </el-form-item>
        <el-form-item label="企业邮箱" prop="Mailbox" >
          <el-input v-model="formData.Mailbox"></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="DepositBank" >
          <el-input v-model="formData.DepositBank"></el-input>
        </el-form-item>
        <el-form-item label="开户账号" prop="BankAccount" >
          <el-input v-model="formData.BankAccount"></el-input>
        </el-form-item>
        <el-form-item label="信用代码" prop="CreditCode" >
          <el-input v-model="formData.CreditCode"></el-input>
        </el-form-item>
      </div>
    </div>
  </el-form>
  <el-dialog :visible.sync="dialogVisible">
    <img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
  </div>
</template>

<script>
import treeSelect from "@/components/common/treeSelect";

export default {
  name: "enterprise",
  components: {treeSelect},
  data() {
    return {
      api: require("@/api/ba/enterprise").default,
      industry: require("@/api/ba/industry").default,
      districtApi: require("@/api/ba/district").default,
      formData: {
        Sn:1,
        ImgUrl:'',
        Status:1,//是否启用状态
        IsAuthentication:false,//是否认证
        AccountNo:'',//账套编号
        AccountName:'',//账套名称
        AccountPath:'',//账套路径
        FullName:'',//单位全称
        ShortName:'',//单位简称
        Industry:'',//最后提交的所属行业
        Industry1:'',
        Industry2:'',
        DistrictId:'',//行政区域Id
        DistrictId1:'',
        DistrictId2:'',
        DistrictId3:'',
        Address:'',//单位地址
        TaxNature:'',//纳税性质
        TaxRate:'',//税率
        Remark:'',//备注
        Legal:'',//法人代表
        Phone:'',//联系电话
        Mailbox:'',//企业邮箱
        DepositBank:'',//开户银行
        BankAccount:'',//开户账号
        CreditCode:'',//信用代码
      },
      ImgUrl: [],
      dialogVisible: false,
      dialogImageUrl:"",
      formRules: {
        AccountNo: [{ required: true, message: '请输入账套信息', trigger: 'blur' }],
        AccountName: [{ required: true, message: '请输入账套名称', trigger: 'blur' }],
        FullName: [{ required: true, message: '请输入单位全称', trigger: 'blur' }],
        ShortName: [{ required: true, message: '请输入单位简称', trigger: 'blur' }],
        // Industry: [{ required: true, message: '请选择所属行业', trigger: 'change' }],
        // DistrictId: [{ type: 'array', required: true, message: '请选择行政区', trigger: 'change' }]
      },
      TaxNatureData:[
        { label: '一般纳税人', value: '一般纳税人' },
        { label: '小规模纳税人', value: '小规模纳税人' },
      ],
      // AreaTreeData: [],
      // AreaProps: {
      //   value: "DistrictId",
      //   label: "NameChain",
      //   children: "children",
      // }
      industryOptions1: [],
      industryOptions2: [],
      areaOptions1:[],
      areaOptions2:[],
      areaOptions3:[]
    };
  },
  activated(){this.init()},
  mounted(){this.init()},
  methods: {
    /** 选中第一个行业 */
    async onIndustry1Select(e){
      /** 获取第二个下拉框的下拉数据 */
      const res = await this.industry.list({Pid:e})
      this.industryOptions2 = res.Data
      this.$set(this.formData,'IndustryId2','')
    },
    // onAreaTreeSelect(t) {
    //   this.formData.DistrictId = t ? t.DistrictId : null;
    // },
    /** 地区1 */
    async onArea1Select(e){
      console.log('切换了地区1');
      const res = await this.districtApi.list({Pid:e})
      this.areaOptions2 = res.Data
      this.$set(this.formData,'DistrictId2','')
      this.$set(this.formData,'DistrictId3','')
    },
    async onArea2Select(e){
      console.log('切换了地区2');
      const res = await this.districtApi.list({Pid:e})
      this.areaOptions3 = res.Data
      this.$set(this.formData,'DistrictId3','')
    },
    arrayToTree(items, styleId) {
      const result = []; // 存放结果集
      const itemMap = {}; //
      for (const item of items) {
        const id = item[styleId];
        const pid = item.Pid;

        if (!itemMap[id]) {
          itemMap[id] = {
            children: [],
          };
        }

        itemMap[id] = {
          ...item,
          children: itemMap[id]["children"],
        };

        const treeItem = itemMap[id];

        if (pid === 0) {
          result.push(treeItem);
        } else {
          if (!itemMap[pid]) {
            itemMap[pid] = {
              children: [],
            };
          }
          itemMap[pid].children.push(treeItem);
        }
      }
      return result;
    },
    masterFileMax(files, fileList) {
      this.$message.warning(`请最多上传 1 张图片。`);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    dealImage(base64, callback) {
      var newImage = new Image();
      var quality = 1; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function () {
        console.log('newImage', [newImage]);
        // if (newImage.width * newImage.height >= 10000) {
        //   //获取原图片20%的宽高
        //   imgWidth = (newImage.width * 0.20).toFixed(0);
        //   imgHeight = (newImage.height * 0.20).toFixed(0);
        // } else {
        //   imgWidth = (newImage.width).toFixed(0);
        //   imgHeight = (newImage.height).toFixed(0);
        // }
        imgWidth = newImage.width;
        imgHeight = newImage.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        console.log('wh', imgWidth, imgHeight);
        canvas.width = imgWidth;
        canvas.height = imgHeight;
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        // quality = 0.9;
        // var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        // console.log("??!-*",base64.length)
        // 如想确保图片压缩到自己想要的尺寸,如要求小于200kb，请加以下语句，quality初始值根据情况自定
        while ((base64.length * 0.75) / 1024 > 200) {
          quality -= 0.1;
          base64 = canvas.toDataURL("image/jpeg", quality);
          // console.log("压缩")
        }
        callback(base64); //必须通过回调函数返回，否则无法及时拿到该值
      };
    },
    beforeUploadHandler(file) {
      var _this = this;
      return new Promise((resolve, reject) => {
        try {
          var reader = new FileReader();
          // 将文件加载进入
          reader.readAsDataURL(file);
          reader.onload = function (e) {
            var base64 = reader.result;
            console.log("原", (base64.length * 0.75) / 1024);
            _this.dealImage(base64, function (new_base64) {
              console.log("后", (new_base64.length * 0.75) / 1024);
              var new_file = _this.dataURLtoFile(new_base64, file.name);
              console.log("new_file", new_file);
              resolve(new_file);
            });
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    fileToBlob(file) {
      const imgBlob = URL.createObjectURL(file);
      return imgBlob;
    },
    fileToBase64(data) {
      return new Promise((resolve, reject) => {
        let rd = new FileReader(); // 创建文件读取对象
        rd.readAsDataURL(data); // 文件读取装换为base64类型
        rd.onload = (e) => {
          resolve(e.currentTarget.result);
          // _this.base64Url = this.result;
          // console.log(_this.ImgUrl);
        };
      });
    },
    /** 图片上传自定义方法 */
    async httpRequest(data) {
      data.file.T = 0;
      data.file.ProductImgId = 0;
      data.file.ProductId = 0;
      data.file.url = this.fileToBlob(data.file);
      data.file.isDefault = false;
      if (this.ImgUrl.length < 1) {
        data.file.isDefault = true;
        this.ImgUrl.push(data.file);
      } else {
        this.ImgUrl.push(data.file);
      }
      this.baseFiles = [];
      this.ImgUrl.forEach(async (item) => {
        const res = await this.fileToBase64(item);
        this.baseFiles.push(res);
      });

      let defaultItem = this.ImgUrl.filter(item => {
        return item.isDefault === true
      })[0];

      this.url = defaultItem.url;
      this.urls = this.ImgUrl.map(item => item.url);
      this.formData.ImgUrl = await this.fileToBase64(data.file);
    },
    /** 浏览图片 */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    /** 删除图片 */
    picRemove(file) {
      // console.log(file);
      // const findIndex = this.ImgUrl.findIndex((item) => item.uid == file.uid);
      // const flag = this.ImgUrl[findIndex].isDefault;
      // if (file.T == 0) {
      //   this.ImgUrl.splice(findIndex, 1);
      // } else {
      //   this.removeImgUrl.push(this.ImgUrl.splice(findIndex, 1)[0]);
      // }
      // if (flag && this.ImgUrl.length > 0) {
      //   this.ImgUrl[0].isDefault = true;
      // }
      // this.baseFiles = [];
      // this.ImgUrl.forEach(async (item) => {
      //   const res = await this.fileToBase64(item);
      //   this.baseFiles.push(res);
      // });
      this.ImgUrl = []
      this.formData.ImgUrl = ''
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const o = {
            EnterpriseId : this.formData.EnterpriseId,
            Sn : this.formData.Sn,
            ImgUrl : this.formData.ImgUrl,
            Status : this.formData.Status,//是否启用状态
            IsAuthentication : this.formData.IsAuthentication,//是否认证
            AccountNo : this.formData.AccountNo,//账套编号
            AccountName : this.formData.AccountName,//账套名称
            AccountPath: this.formData.AccountPath,//账套路径
            FullName : this.formData.FullName,//单位全称
            ShortName : this.formData.ShortName,//单位简称
            Industry : this.formData.IndustryId2 ? this.formData.IndustryId2 : this.formData.IndustryId1,//所属行业
            // IndustryId1 : this.formData.IndustryId1,//所属行业1
            // IndustryId2 : this.formData.IndustryId2,//所属行业2
            DistrictId : this.formData.DistrictId3 ? this.formData.DistrictId3 : this.formData.DistrictId2 ? this.formData.DistrictId2 :this.formData.DistrictId1,//行政区域Id
            Address : this.formData.Address,//单位地址
            TaxNature : this.formData.TaxNature,//纳税性质
            TaxRate : this.formData.TaxRate,//税率
            Remark : this.formData.Remark,//备注
            Legal : this.formData.Legal,//法人代表
            Phone : this.formData.Phone,//联系电话
            Mailbox : this.formData.Mailbox,//企业邮箱
            DepositBank : this.formData.DepositBank,//开户银行
            BankAccount : this.formData.BankAccount,//开户账号
            CreditCode : this.formData.CreditCode,//信用代码
          }
          // console.log('保存前o',o);
          // const params = this.$commonJs.obj.removeNullKey(o);
          
      if(!o.Industry){
        this.$message.error('请选择所属行业')
        return
      }
      if(!o.DistrictId){
        this.$message.error('请选择所属区域')
        return
      }
          this.api.save(o).then(res => {
            if(res.Code == 0){
              this.$message.success("保存成功");
              this.api.info().then(res => {
                this.formData = res.Data
              })
            }else{
              this.$message.error("保存失败");
            }
          })
        } else {
          this.$message.error('表单校验失败，请检查表单');
        }
      });
    },
    async init(){
      /** 获取所属行业 */
      this.industry.list({Pid:0}).then((res) => {
        this.industryOptions1 = res.Data
      });
      /** 获取地区 */
      this.districtApi.list({Pid:0}).then((res) => {
        // this.areaOptions1 = this.arrayToTree(res.Data, "DistrictId");
        this.areaOptions1 = res.Data
      });
      /** 获取 */
      const res = await this.api.info()
      this.formData = res.Data

      this.industry.list({Pid:res.Data.IndustryId1}).then((res) => {
        this.industryOptions2 = res.Data
      });

      this.districtApi.list({Pid:res.Data.DistrictId1}).then((res) => {
        this.areaOptions2 = res.Data
      });

      this.districtApi.list({Pid:res.Data.DistrictId2}).then((res) => {
        this.areaOptions3 = res.Data
      });
      

      const { ImgUrl, ...newObj } = this.formData;
      localStorage.setItem("enterprise", JSON.stringify(newObj));  
      // setTimeout(() => {
        // this.$refs.areaTreeSelect.setData(this.formData.DistrictId);
      // }, 500);
      let imageItem = {
        url:this.formData.ImgUrl
      }
      this.ImgUrl = [imageItem]
    },
  }
};
</script>